@use "stylesheets/utility/variables";

.formWrapper {
  margin: 40px auto;
  max-width: 450px;

  @media screen and (min-width: variables.$laptop) {
    margin: 195px auto 0;
  }
}

.formTitle {
  margin-top: 0;
}

.forgotPasswordLink {
  margin-bottom: 20px;
}

.alerts {
  margin: 10px 0;
}
